import ButtonLink from '@v2/shared/components/ButtonLink';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';
import { cn } from '@v2/shared/lib/utils';
import SectionCard from './SectionCard';
import { H2 } from './styles';
import { HelpAction } from './types';
import { liveAgentHours } from '@v2/shared/lib/supportHours';

const CONTACT_ACTIONS: HelpAction[] = [
  { label: 'Contact Customer Care', href: '/contact', primary: true },
  { label: 'My Orders', href: '/customer?xCmd=orders' },
  { label: 'DiscountLock', href: '/my-account/discountlock' },
];

/** "Still need help?" -- the last card on every page. */
export default function StillNeedHelp() {
  const { buildUrl } = useUrlGenerator();

  return (
    <SectionCard>
      <div className="grid grid-cols-1 items-center gap-4 md:grid-cols-[1fr_auto]">
        <div>
          <h2 className={cn(H2, 'mb-1.5')}>Still need help?</h2>
          <p className="m-0 text-slate-500">
            Most things can be done instantly in your account. For everything else, send us a message and a
            member of our U.S.-based team replies by email.
          </p>
          <p className="mb-0 mt-1.5 text-[13px] text-slate-500">
            Automated order support: 24/7 · Live agents: {liveAgentHours()}
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          {CONTACT_ACTIONS.map((action) => (
            <ButtonLink
              key={action.href}
              href={buildUrl(action.href)}
              className={action.primary ? undefined : 'border-primary bg-white text-primary'}
            >
              {action.label}
            </ButtonLink>
          ))}
        </div>
      </div>
    </SectionCard>
  );
}
